import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { SQUAD_TV_STADIUM_COLORS } from '../../../src/worldcup/constants/squadTvMode.constants';

export const getSquadTvTopBarStyles = (theme: Theme) =>
  StyleSheet.create({
    bar: {
      flexDirection: 'row',
      alignItems: 'center',
      height: 104,
      paddingHorizontal: 44,
      borderBottomWidth: 1,
      borderBottomColor: SQUAD_TV_STADIUM_COLORS.borderStrong,
      backgroundColor: theme.background.primary,
      overflow: 'hidden',
    },
    bannerImage: {
      ...StyleSheet.absoluteFillObject,
    },
    brandGradient: {
      ...StyleSheet.absoluteFillObject,
    },
    bannerScrim: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(6,13,20,0.78)',
    },
    left: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 18,
      flex: 1,
    },
    logoBadge: {
      width: 60,
      height: 60,
      borderRadius: 14,
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.cardElevated,
    },
    logoImage: {
      width: '100%',
      height: '100%',
    },
    titleBlock: {
      flexShrink: 1,
    },
    title: {
      fontSize: 30,
      fontWeight: '800',
      color: theme.gray[900],
      letterSpacing: -0.3,
    },
    subtitle: {
      fontSize: 13,
      fontWeight: '600',
      letterSpacing: 1.3,
      color: theme.gray[400],
      textTransform: 'uppercase',
      marginTop: 3,
    },
    right: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 22,
    },
    prizeLine: {
      alignItems: 'flex-end',
    },
    prizeLabel: {
      fontSize: 11,
      fontWeight: '700',
      letterSpacing: 2,
      color: theme.accent,
      textTransform: 'uppercase',
    },
    prizeText: {
      fontSize: 15,
      fontWeight: '600',
      color: theme.gray[600],
      marginTop: 2,
    },
    clock: {
      fontSize: 26,
      fontWeight: '800',
      color: theme.gray[900],
      fontVariant: ['tabular-nums'],
    },
    mascot: {
      width: 76,
      height: 76,
    },
  });
